module.exports = __webpack_public_path__ + "static/media/services2.f153bc34.png";